const WORKFLOW_TYPE = {
	TWO_STEP: 4, // Represents the ID or type for a two-step workflow
	ONE_STEP: 3, // Represents the ID or type for a one-step workflow
}

export default class workflowMaintainerCtrl {

	constructor($scope, $state, $stateParams, ngNotify, $timeout, GlobalSrv, UserInfoConstant, perfilSrv, $mdDialog, FileUploader, SERVICE_URL_CONSTANT, $cookies, $rootScope, $interval) {
		this.$scope = $scope
		this.$state = $state
		this.ngNotify = ngNotify
		this.$timeout = $timeout
		this.perfilSrv = perfilSrv
		this.$mdDialog = $mdDialog

		$rootScope.fullscreenClass = 'background-planning'
		this.workflows = {}

		this.$scope.profileForms = {
			enableRowSelection       : true,
			enableRowHeaderSelection : false,
			multiSelect              : false,
			modifierKeysToMultiSelect: false,
			noUnselect               : true,
			enableFiltering          : false,
			enableAutoResize         : true,
			columnDefs               : [
				{
					name            : 'Tipo de Perfil',
					displayName     : 'Tipo de Perfil',
					field           : 'formName',
					width           : '20%',
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'text-xs',
					headerCellClass : 'text-xs',
				}, {
					name            : 'Estado',
					displayName     : 'Estado',
					field           : 'is_active',
					width           : '20%',
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'text-xs',
					headerCellClass : 'text-xs',
					cellTemplate    : `<div class="ui-grid-cell-contents">
											<div ng-if="row.entity.is_active===1">
												{{'ACTIVE' | translate}}
											</div>
											<div ng-if="row.entity.is_active!==1"> 
												{{'NOT_ACTIVE' | translate}}
											</div>
										</div>`,
				}, {
					name            : 'Cant. Revisores',
					displayName     : 'Cant. Revisores',
					field           : 'reviewerCount',
					width           : '20%',
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'column-center text-xs',
					headerCellClass : 'column-center text-xs',
					cellTemplate    : `<div class="ui-grid-cell-contents">
											<div ng-if="row.entity.id_workflow===4">
												{{row.entity.reviewerCount}}
											</div>
											<div ng-if="row.entity.id_workflow===3"> 
												{{'DOES_NOT_APLLY' | translate}}
											</div>
										</div>`,
				}, {
					name            : 'Cant. Aprobadores',
					displayName     : 'Cant. Aprobadores',
					field           : 'approverCount',
					width           : '20%',
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'column-center text-xs',
					headerCellClass : 'column-center text-xs',
				}, {
					name            : 'Acciones',
					displayName     : 'Acciones',
					field           : 'id_code',
					width           : '20%',
					enableGridMenu  : false,
					enableFiltering : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'column-center text-xs text-azul',
					headerCellClass : 'column-center ',
					cellTemplate    : `<div class="ui-grid-cell-contents">
										<div>
											<button 
											md-ink-ripple 
											class="btn btn-accent sm-btn p-xs" 
											type="button" 
											ng-click="grid.appScope.workflowMaintainerCtrl.showModalEditWorkflow(row.entity)" 
											style="padding-top: 0px; height: 20px;">Editar</button>
										</div>
									</div>
									`,
				},
			],
			onRegisterApi: (gridApi) => {
				this.gridApi = gridApi
				$interval(() => {
					if (this.gridApi && this.gridApi.core) {
						this.gridApi.core.handleWindowResize()
					}
				}, 500)
			},
		}

		this.main()
	}

	main() {
		this.perfilSrv.perfildocente.getUpdateFormsMaintainer().$promise.then((dataReturn) => {
			this.$scope.profileForms.data = dataReturn.data.forms
			this.userList = dataReturn.data.users
		})
			.catch((error) => {
				this.ngNotify.set('Error cargando datos iniciales del mantenedor.', 'error')
				console.error('Error in main():', error)
			})
	}

	searchUsers(text) {
		let matcher = new RegExp(text, 'i')
		let arr = []

		this.userList.forEach((user) => {
			if (user.ds_fullname.match(matcher)) {
				arr.push(user)
			}
		})

		return arr
	}

	showModalEditWorkflow (profileForm) {
		this.$mdDialog.show({
			controller: [ '$scope', '$mdDialog', '$state', 'ngNotify', 'profileFormLocal', 'workFlowRolesLocal', 'perfilSrvLocal', 'userListLocal', 'searchUsersFnLocal',
				function modalWorkflowMaintainer ($scope, $mdDialog, $state, ngNotify, profileFormLocal, workFlowRolesLocal, perfilSrvLocal, userListLocal, searchUsersFnLocal) {
					const modalVM = this

					modalVM.selectedForm = angular.copy(profileFormLocal) // Work with a copy
					modalVM.selectedForm.twoStepFlow = modalVM.selectedForm.id_workflow === WORKFLOW_TYPE.TWO_STEP // Use boolean
					modalVM.selectedForm.is_active = profileForm.is_active
					modalVM.workFlowRoles = workFlowRolesLocal
					modalVM.userList = userListLocal
					modalVM.selectedReviewerUser = null
					modalVM.selectedApproverUser = null
					modalVM.searchApproverText = ''
					modalVM.searchReviewerText = ''
					modalVM.searchUsers = searchUsersFnLocal

					modalVM.reviewerUsers = []
					modalVM.approverUsers = []
					modalVM.loading = true
					modalVM.saveButtonDisabled = false

					perfilSrvLocal.workflows.getFormUsers({ formId: modalVM.selectedForm.id_code }).$promise.then((dataReturn) => {
						const reviewerIds = new Set(dataReturn.data.reviewers.map(us => us.id_user))
						const approverIds = new Set(dataReturn.data.approvers.map(us => us.id_user))

						modalVM.reviewerUsers = modalVM.userList.filter((user) => reviewerIds.has(user.id_code))
						modalVM.approverUsers = modalVM.userList.filter((user) => approverIds.has(user.id_code))
						modalVM.loading = false
					}).catch((error) => {
						ngNotify.set('Error cargando usuarios asignados al formulario.', 'error')
						modalVM.loading = false
						console.error('Error fetching form users:', error)
					})

					modalVM.close = () => {
						$mdDialog.hide()
					}

					modalVM.toggleActive = () => {
						modalVM.selectedForm.is_active = !modalVM.selectedForm.is_active
					}

					modalVM.addReviewerUser = (user) => {
						if (user && !modalVM.reviewerUsers.some(us => us.id_code === user.id_code)) {
							modalVM.reviewerUsers.push(user)
						}

						modalVM.selectedReviewerUser = null // Clear autocomplete selection
						modalVM.searchReviewerText = ''
					}

					modalVM.dropReviewerUser = (index) => {
						modalVM.reviewerUsers.splice(index, 1)
					}

					modalVM.addApproverUser = (user) => {
						if (user && !modalVM.approverUsers.some(us => us.id_code === user.id_code)) {
							modalVM.approverUsers.push(user)
						}

						modalVM.selectedApproverUser = null // Clear autocomplete selection
						modalVM.searchApproverText = '' 
					}

					modalVM.dropApproverUser = (index) => {
						modalVM.approverUsers.splice(index, 1)
					}

					modalVM.saveWorkflow = () => {
						if (modalVM.selectedForm.is_active) {
							if (modalVM.selectedForm.twoStepFlow && modalVM.reviewerUsers.length === 0) {
								ngNotify.set('Debe asignar al menos un revisor para el flujo de dos pasos.', 'warn')
	
								return
							}
	
							if (modalVM.approverUsers.length === 0) {
								ngNotify.set('Debe asignar al menos un aprobador.', 'warn')
	
								return
							}
						}
						
						modalVM.saveButtonDisabled = true

						const reviewerUserIds = modalVM.reviewerUsers.map(user => ({ userId: user.id_code }))
						const approverUserIds = modalVM.approverUsers.map(user => ({ userId: user.id_code }))

						const workflowPayload = {
							profileFormworkFlow: modalVM.selectedForm.twoStepFlow ? WORKFLOW_TYPE.TWO_STEP : WORKFLOW_TYPE.ONE_STEP,
							twoStepFlow        : modalVM.selectedForm.twoStepFlow,
							profileFormId      : modalVM.selectedForm.id_code,
							active             : modalVM.selectedForm.is_active,
							reviewers          : modalVM.selectedForm.twoStepFlow ? reviewerUserIds : [],
							approvers          : approverUserIds,
						}

						perfilSrvLocal.workflows.setProfileUpdateWorkflow(workflowPayload).$promise.then((dataReturn) => {
							if (dataReturn.status) {
								$state.reload() // Consider updating grid data directly for better UX
								showModalSuccess().then(() => {
									$mdDialog.hide()
								})
							} else {
								ngNotify.set(dataReturn.message || 'No se ha podido guardar el flujo de trabajo.', 'error')
								modalVM.saveButtonDisabled = false
							}
						}).catch((error) => {
							ngNotify.set('Error al conectar con el servicio para guardar el flujo.', 'error')
							modalVM.saveButtonDisabled = false
							console.error('Error saving workflow:', error)
						})
					}

					function showModalSuccess () {
						return $mdDialog.show({ // Return the promise
							controller: [ '$scope', '$mdDialog', function ($scope, $mdDialog) {
								$scope.close = function () {
									$mdDialog.hide()
								}
							} ],
							template           : require('./modalSuccessWorkflowForm.html'),
							clickOutsideToClose: false,
						})
					}
				},
			],
			template           : require('./modalWorkflowMaintainer.html'),
			controllerAs       : 'modalVM', // Use this in the modal's template
			clickOutsideToClose: false,
			locals             : {
				profileFormLocal  : profileForm,
				workFlowRolesLocal: this.workFlowRoles,
				perfilSrvLocal    : this.perfilSrv,
				userListLocal     : this.userList,
				searchUsersFnLocal: (text) => this.searchUsers(text), // Ensure 'this' context is correct
			},
		})
	}

}

workflowMaintainerCtrl.$inject = [ '$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'GlobalSrv', 'UserInfoConstant', 'perfilSrv', '$mdDialog', 'FileUploader', 'SERVICE_URL_CONSTANT', '$cookies', '$rootScope', '$interval' ]


// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/workflowMaintainer/workflowMaintainerCtrl.js